import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleChangeInputInstallmentsFactorPage } from '../../../../redux/actions/pages/installments_factor';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { BASE_SITE, INSTALLMENTS_FACTOR_GET, ACCEPT_INSTALLMENTS_FACTOR_POST } from '../../../../apis';
import axios from "axios";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import { DatePicker } from "react-advance-jalaali-datepicker";
import { handleChangeDataModalTransDetails } from '../../../../redux/actions/partials/modals/modalTransDetails';
import { handleChangeDataModalRejectFactor } from '../../../../redux/actions/partials/modals/modalRejectFactor'
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import Swal from 'sweetalert2';
import SitagLogo from '../../../../styles/images/sitag-logo.png';
import * as qs from "querystring";


const InstallmentsFactor = () => {

	const dispatch = useDispatch();


	const { token, profile } = useSelector(state => state.login);
    const { factors, title, fromDate, startTime, toDate, endTime, branchOptions, branchSelect } = useSelector(state => state.installmentsFactor);

    

    useEffect(() => {
        callApiGetFactors();
        // eslint-disable-next-line
    }, [InstallmentsFactor]);


    const [isSearchVisible, setIsSearchVisible] = useState(false);

    const [isHeadingElementsVisible, setIsHeadingElementsVisible] = useState(false);

    const [time, setTime] = useState(null);


    const callApiGetFactors = (event) => {
        if(event !== undefined)
            event.preventDefault();
        dispatch(handleSetBackdropLoading(true));

        axios({
            method: 'get',
            url: BASE_SITE + INSTALLMENTS_FACTOR_GET,
            params: {from_date: fromDate, to_date: toDate, start_time: startTime, end_time: endTime, branch: branchSelect},
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token,
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                    dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'top', horizontal: 'right'}));
                    break;
                case 'ok':
                    dispatch(handleChangeInputInstallmentsFactorPage('factors', response.data.factors));
                    dispatch(handleChangeInputInstallmentsFactorPage('branchOptions', response.data.branch_options));
                    dispatch(handleChangeInputInstallmentsFactorPage('title', response.data.title));
                    break;
                default:
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
            }
            dispatch(handleSetBackdropLoading(false));
        }, () => {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
            dispatch(handleSetBackdropLoading(false));
        });
    };



    const buttonsOkCancel = Swal.mixin({
        customClass: {
            confirmButton: 'btn  btn-outline-primary width-80 mr-2',
            cancelButton: 'btn grey btn-outline-secondary width-80',
        },
        buttonsStyling: false
    });

    const showModalConfirm = (key) => {
        // dispatch(handleChangeDataModalTransDetails('isOpen', true));
        // dispatch(handleChangeDataModalTransDetails('data', trans[key]));
        buttonsOkCancel.fire({
            text: "آیا از تایید فاکتور اطمینان دارید؟ در صورت تایید امکان ویرایش وجود ندارد",
            imageUrl: SitagLogo,
            imageHeight: 80,
            imageAlt: 'سیتگ',
            confirmButtonText: "بله",
            showCancelButton: true,
            cancelButtonText: 'انصراف',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(handleSetBackdropLoading(true));
                axios({
                    method: 'post',
                    url: BASE_SITE + ACCEPT_INSTALLMENTS_FACTOR_POST,
                    data: qs.stringify({
                        factor: factors[key].id,
                    }),
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': token
                    },
                }).then((response) => {
                    switch (response.data.status) {
                        case 'error':
                            dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                            break;
                        case 'ok':
                            dispatch(handleSetOpenCustomSnackbar(true, {message: 'فاکتور مورد نظر با موفقیت تایید شد', severity: 'success', vertical: 'bottom', horizontal: 'center'}));  
                            callApiGetFactors();
                            break;
                        default:
                            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در خروج! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                    }
                    dispatch(handleSetBackdropLoading(false));
                }, () => {
                    dispatch(handleSetBackdropLoading(false));
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در خروج! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                });
            }
        }); 
    };

    const showModalEditFactorNum = (key) => {
        // dispatch(handleChangeDataModalEditTransFactorNum('isOpen', true));
        // dispatch(handleChangeDataModalEditTransFactorNum('transNum', trans[key].id));
        // dispatch(handleChangeDataModalEditTransFactorNum('transKey', key));
    };



    const handleStartTimeChange = (selectedDates) => {
        if (selectedDates.length > 0) {
            const date = selectedDates[0];
            const formattedTime = date.toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false, // برای نمایش ۲۴ ساعته
            });

            dispatch(handleChangeInputInstallmentsFactorPage('startTime', formattedTime)); 
        }
    };

    const handleEndTimeChange = (selectedDates) => {
        if (selectedDates.length > 0) {
            const date = selectedDates[0];
            const formattedTime = date.toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false, // برای نمایش ۲۴ ساعته
            });

            dispatch(handleChangeInputInstallmentsFactorPage('endTime', formattedTime)); 
        }
    };



    const handleChangeBranch = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeInputInstallmentsFactorPage(name, value));
    };



    const DatePickerInput = (props) => {
        return <input className="popo" {...props} />;
    };

    const changeFromDate = (unix, formatted) => {
       dispatch(handleChangeInputInstallmentsFactorPage('fromDate', formatted)); 
    };

    const changeToDate = (unix, formatted) => {
       dispatch(handleChangeInputInstallmentsFactorPage('toDate', formatted)); 
    };


    const showModalConfirmDelete = (key) => {
        dispatch(handleChangeDataModalRejectFactor('isOpen', true)); 
        dispatch(handleChangeDataModalRejectFactor('factorNum', factors[key].id));
        dispatch(handleChangeDataModalRejectFactor('factorKey', key));
    };


    return (
		<div className="app-content content container-fluid">
            <div className="content-wrapper">
                <div className="content-header row">
                </div>
                <div className="content-body">




                    <Row>
                        <Col className="col-xs-12">
                            <div className="card" style={{minHeight: 'unset !important'}} >
                                <div className="card-header">
                                    <h4 className="card-title">لیست  فاکتور ها{title} </h4>
                                    <a className="heading-elements-toggle" onClick={() => setIsHeadingElementsVisible(! isHeadingElementsVisible)}><i className="icon-ellipsis font-medium-3"></i></a>
                                    <div className={`heading-elements ${isHeadingElementsVisible ? 'visible' : ''}`}>
                                        <ul className="list-inline mb-0">
                                            <li><a data-action="collapse"><i className="icon-minus4"></i></a></li>
                                            <li><a data-action="expand"><i className="icon-expand2"></i></a></li>
                                            <li><a onClick={() => setIsSearchVisible(! isSearchVisible)}><i className="icon-search"></i></a></li>
                                            <li><a onClick={() => callApiGetFactors()} title="رفرش"><i className="icon-reload" style={{color: '#0100fe'}}></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="card-body collapse in">

                                    {isSearchVisible && (
                                    <motion.div 
                                        className="card-block" id="div-search"
                                        initial={{ opacity: 0, height: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, height: "auto", scale: 1 }}
                                        exit={{ opacity: 0, height: 0, scale: 0.8 }}
                                        transition={{ duration: 0.5, ease: "easeOut" }} >
                                        <form onSubmit={callApiGetFactors} >
                                            <div className="form-body" style={{overflow: 'unset !important'}} >
                                                <Row className="row">
                                                    <div style={{display: 'flex', justifyContent: 'flex-start'}}>
                                                        <div>

                                                            { profile.type !== 'cashier' ?
                                                            <>
                                                            <DatePicker
                                                                icon="fa fa-calendar"
                                                                inputComponent={DatePickerInput}
                                                                placeholder="از تاریخ"
                                                                format="jYYYY/jMM/jDD"
                                                                id="datePicker"
                                                                preSelected={""}
                                                                value={fromDate}
                                                                onChange={changeFromDate}
                                                                cancelOnBackgroundClick={true}
                                                                containerClass={"form-group col-md-3 col-xl-2 date-picker pos-initial"}
                                                            />
                                                            <input type="hidden" name="from_date" value={fromDate} />

                                                            <Col className="form-group col-md-3 col-xl-2 ">
                                                                <Flatpickr
                                                                        value={startTime}
                                                                        onChange={handleStartTimeChange}
                                                                        options={{
                                                                            enableTime: true,
                                                                            noCalendar: true,
                                                                            dateFormat: "H:i",
                                                                            time_24hr: true,
                                                                        }}
                                                                        className="input-style form-control"
                                                                        placeholder="از ساعت"
                                                                />
                                                            </Col>


                                                            <DatePicker
                                                                icon="fa fa-calendar"
                                                                inputComponent={DatePickerInput}
                                                                placeholder="تا تاریخ"
                                                                format="jYYYY/jMM/jDD"
                                                                id="datePicker"
                                                                preSelected={""}
                                                                value={toDate}
                                                                onChange={changeToDate}
                                                                cancelOnBackgroundClick={true}
                                                                containerClass={"form-group col-md-3 col-xl-2 date-picker pos-initial"}
                                                            />
                                                            <input type="hidden" name="to_date" value={toDate} />

                                                            <Col className="form-group col-md-3 col-xl-2 ">
                                                                <Flatpickr
                                                                        value={endTime}
                                                                        onChange={handleEndTimeChange}
                                                                        options={{
                                                                            enableTime: true,
                                                                            noCalendar: true,
                                                                            dateFormat: "H:i",
                                                                            time_24hr: true,
                                                                        }}
                                                                        className="input-style form-control"
                                                                        placeholder="تا ساعت"
                                                                />
                                                            </Col>
                                                            {
                                                                profile.type === 'manager' ? 
                                                                    <Col className="form-group col-md-3 col-xl-2 ">
                                                                        <select name="branchSelect" value={branchSelect} className="input-style form-control" onChange={handleChangeBranch}>
                                                                        { 
                                                                            branchOptions.map((branch, key) => {
                                                                                return (
                                                                                    <option value={branch.id} key={key}>{branch.title}</option>
                                                                                );
                                                                            })

                                                                        }
                                                                        </select>
                                                                    </Col>
                                                                : ''
                                                            }
                                                            </>
                                                            : profile.type == 'financial' ?
                                                            <Col className="form-group col-md-3 col-xl-2 ">

                                                            </Col>
                                                            :''
                                                            }
                                                            <Col className="form-group col-md-3 col-xl-2 ">
                                                                <button type="submit" id="btn-search" className="btn btn-success w-100" name="search_btn" value="search" >
                                                                    <i className="icon-search"></i> جستجو 
                                                                </button>
                                                            </Col>
                                                        </div>
                                                    </div>
                                                </Row>
                                            </div>
                                        </form>
                                    </motion.div>
                                    )}

                                    <div className="table-responsive">
                                        <table className="table mb-0 table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th style={{width: '1%'}} >#</th>
                                                    <th>نام کاربر</th>
                                                    <th>شعبه</th>
                                                    <th>مبلغ (ریال)</th>
                                                    <th>تاریخ</th>
                                                    <th>تصویر</th>
                                                    <th>شماره فاکتور</th>
                                                    <th>عملیات</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    factors && factors.map((factorItem, key) => {
                                                        return(
                                                            <tr key={`factor-${key}`}>
                                                                <td> {key + 1} </td>
                                                                <td> {factorItem.user_fullname} </td>
                                                                <td> {factorItem.branch_title} </td>
                                                                <td> {factorItem.amount} </td>
                                                                <td> {factorItem.reg_date} </td>
                                                                <td> 
                                                                    <a href={factorItem.image} target="_blank">
                                                                        <img src={factorItem.image} width={60} />
                                                                    </a>
                                                                </td>
                                                                <td> {factorItem.factor_num} </td>
                                                                <td>
                                                                    { factorItem.shop_status === '0' ?
                                                                        <>
                                                                        <a href="#!" style={{marginRight: '0'}} className="btn-details" title="تایید" 
                                                                                onClick={() => showModalConfirm(key)} >
                                                                            <i className="icon-checkmark-round" style={{fontSize: '24px'}}  ></i>
                                                                        </a>
                                                                        <a href="#!" style={{marginRight: '0'}} className="btn-details" title="رد" 
                                                                                onClick={() => showModalConfirmDelete(key)} >
                                                                            <i className="icon-close-round" style={{fontSize: '24px', marginLeft: '20px'}}  ></i>
                                                                        </a>
                                                                        </>
                                                                    :
                                                                        <span>{factorItem.shop_status_txt}</span>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <nav aria-label="Page navigation" className="text-xs-center" style={{marginTop: '3%'}} >

                                    </nav>
                                </div>
                            </div>
                        </Col>
                    </Row>





                </div>
            </div>
        </div>
    );
}

export default InstallmentsFactor;